
import { Component, Prop, Vue } from "vue-property-decorator";

import TableListChipNew from "@/components/table/table-list-chip-new.vue";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import Card from "@/components/card/ResourceCards.vue";
import ProjectModal from "@/components/companyProjects/ProjectModal.vue";
import GroupModal from "@/components/teams/GroupModalNew.vue";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMoreNew.vue";
import UiButton from "@/components/button/ui-button.vue";
import CardInfoChip from "@/components/card/CardInfoChip.vue";
import CircleWithInitials from "@/components/card/CircleWithInitialsNew.vue";
import CreateGroupConversationModal from "@/components/inbox/CreateGroupConversationModalNew.vue";
import ColorIconContainer from "@/components/icons/ColorIconContainer.vue";
import ChatIcon from "@/components/icons/ChatIcon.vue";
import ConversationUserDataForModal from "@/entities/ConversationUserDataForModal";
import ItemChipsData from "@/entities/ItemChipsData";
import Roles from "@/entities/Roles";
import { User, Team } from "@/generated/graphql";
import RouteNames from "@/entities/RouteNames";
import ItemChip from "@/components/common/ItemChipNew.vue";
import ResouceIcon from "@/components/icons/Resource.vue";
import PostingIcon from "@/components/icons/Postings.vue";
import ProjectsIcon from "@/components/icons/Projects-group-icon.vue";
import ProfileIcon from "@/components/icons/profile.vue";
import LocationIconNew from "@/components/icons/LocationIconNew.vue";
import EmployeeRemovedFromCompanyTooltip from "@/components/tooltip/EmployeeRemovedFromCompanyTooltip.vue";
import GroupConversationProvider from "@/components/teams/GroupConversationProvider.vue";

interface groupParticipants {
  id: string;
  userId: string;
  name: string;
  role?: string;
  avatar: string;
}

interface groupContractors extends groupParticipants {
  deleted: boolean;
}

@Component({
  components: {
    EmployeeRemovedFromCompanyTooltip,
    ItemChip,
    GroupConversationProvider,
    TableListChipNew,
    ResouceIcon,
    CardBodyItem,
    Card,
    ProjectModal,
    PostingIcon,
    ProjectsIcon,
    ProfileIcon,
    LocationIconNew,
    GroupModal,
    ItemChipsWithMore,
    UiButton,
    CardInfoChip,
    CircleWithInitials,
    CreateGroupConversationModal,
    ColorIconContainer,
    ChatIcon,
  },
})
export default class GroupCard extends Vue {
  @Prop({ type: Object, required: true }) readonly group!: Team;
  @Prop({ type: String, default: undefined }) readonly companyId!: string;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  @Prop({ type: String, default: undefined }) readonly name?:
    | string
    | undefined;
  @Prop({ type: String, required: true }) readonly groupId?: string;
  @Prop({ type: String, default: undefined }) readonly location?:
    | string
    | undefined;
  @Prop({ type: Array, default: () => [] }) readonly managers!: [];
  @Prop({ type: Array, default: () => [] }) readonly postings!: [];
  @Prop({ type: Array, default: () => [] }) readonly contractors!: [];
  @Prop({ type: Array, default: () => [] }) readonly projects!: [];
  @Prop({ type: Array, default: () => [] }) readonly skills!: [];
  @Prop({ type: Boolean, default: false }) readonly active!: boolean;
  @Prop({ type: Boolean, default: false }) readonly archived!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isAdmin!: boolean;

  dialog: boolean = false;
  routes = RouteNames;
  newConversationDialog: boolean = false;

  get groupDetailsRouteName(): string {
    return RouteNames.GROUP_DETAILS;
  }

  get groupName(): string | undefined {
    return this.name;
  }

  get groupLocation(): string | undefined {
    if (!this.location) {
      return undefined;
    }
    return this.location;
  }

  get groupManagers(): groupParticipants[] {
    if (!this.managers.length || !this.isAdmin) {
      return [];
    }
    return this.managers.map(({ manager }: any) => {
      return {
        id: manager.id,
        userId: manager.user.id,
        name: `${manager.user.given_name} ${manager.user.family_name}`,
        avatar: manager.user.avatar,
      };
    });
  }

  get groupContractors(): groupContractors[] {
    if (!this.contractors.length) {
      return [];
    }
    return this.contractors.map(({ contractor }: any) => {
      return {
        id: contractor.id,
        userId: contractor.user.id,
        name: `${contractor.user.given_name} ${contractor.user.family_name}`,
        role: Roles.CONTRACTOR,
        avatar: contractor.user.avatar,
        deleted: contractor.deleted,
      };
    });
  }

  get hasParticipants(): boolean {
    return this.conversationParticipants.length > 0;
  }

  get conversationParticipants(): ConversationUserDataForModal[] {
    const managers = this.groupManagers.map((manager) => {
      return {
        ...manager,
        name: `${manager.name} (manager)`,
      };
    });
    return [...this.groupContractors, ...managers];
  }

  get groupProjects(): any[] {
    if (!this.projects.length) {
      return [];
    }
    return this.projects.map(({ project }: any) => {
      return {
        id: project.id,
        name: project?.client_name,
      };
    });
  }

  get groupPostings(): ItemChipsData[] {
    if (!this.postings.length) {
      return [];
    }
    return this.postings.map(({ posting }: any) => {
      return {
        id: posting.id,
        name: posting.job_title,
      };
    });
  }

  get groupSkills(): ItemChipsData[] {
    if (!this.skills.length) {
      return [];
    }
    return this.skills.map(({ skill }: any) => {
      return {
        id: skill.id,
        name: skill.name,
      };
    });
  }

  get navigateToDetails(): Object {
    return {
      name: RouteNames.GROUP_DETAILS,
      params: { id: this.groupId },
    };
  }

  handleEditClick(): void {
    this.dialog = true;
  }

  groupMessage(): void {
    this.newConversationDialog = true;
  }
}
